import { initialState, WorkOrdersState, workOrdersAdapter } from './work-orders.interfaces';
import * as fromWorkOrders from './work-orders.actions';

export function reducer(state = initialState, action: fromWorkOrders.WorkOrdersAction): WorkOrdersState {
  switch (action.type) {
    case fromWorkOrders.GET_WORK_ORDERS_FROM_SERVER_SUCCESS: {
      return {
        ...workOrdersAdapter.addMany(action.payload.workOrders, state)
      };
    }
    case fromWorkOrders.GET_WORK_ORDER_FROM_SERVER_SUCCESS: {
      return {
        ...workOrdersAdapter.addOne(action.payload.workOrder, state)
      };
    }

    default: {
      return state;
    }
  }
}
